<template>
  <div class="l-content">
    <main class="l-simple">
      <slot />
    </main>
  </div>
</template>

<script>
export default {
  name: 'Simple'
}
</script>
